import axios from "axios";
import { AUTH_API_BASE_URL } from "../ApiBaseUrl";

const getServices = () => {
    return axios.get(AUTH_API_BASE_URL + "/nrg-service");
};

const postServices = (data) => {
    return axios.post(AUTH_API_BASE_URL + "/nrg-service", data);
};

const updateService = (srvId, data) => {
    return axios.put(AUTH_API_BASE_URL + "/nrg-service/" + srvId, data);
};

const getServiceById = (srvId) => {
    return axios.get(AUTH_API_BASE_URL + "/nrg-service/" + srvId);
};

const deleteService = (srvId) => {
    return axios.delete(AUTH_API_BASE_URL + "/nrg-service/" + srvId);
};

const uploadImages = (srvId, files) => {
    const url = `${AUTH_API_BASE_URL}/service/${srvId}/images`;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
    }
    return axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

const listImages = (srvId) => {
    const url = `${AUTH_API_BASE_URL}/service/${srvId}/images`;
    return axios.get(url);
};

const getImage = (srvId, imgId) => {
    const url = `${AUTH_API_BASE_URL}/service/${srvId}/images/${imgId}`;
    return axios.get(url, { responseType: "blob" });
};

const replaceImage = (srvId, imgId, file) => {
    const url = `${AUTH_API_BASE_URL}/service/${srvId}/images/${imgId}`;
    const formData = new FormData();
    formData.append("file", file);
    return axios.put(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

const updateImageMetadata = (srvId, imgId, payload) => {
    const url = `${AUTH_API_BASE_URL}/service/${srvId}/images/${imgId}`;
    return axios.patch(url, payload);
};

const deleteImage = (srvId, imgId) => {
    const url = `${AUTH_API_BASE_URL}/service/${srvId}/images/${imgId}`;
    return axios.delete(url);
};

const getPendingMessages = () => {
    return axios.get(AUTH_API_BASE_URL + "/nrg-pend-client-message");
};

const getMessages = () => {
    return axios.get(AUTH_API_BASE_URL + "/nrg-client-message");
};

const getDoneMessages = () => {
    return axios.get(AUTH_API_BASE_URL + "/nrg-del-client-message");
};

const postMessages = (data) => {
    return axios.post(AUTH_API_BASE_URL + "/nrg-client-message", data);
};

const updateMessages = (msgId, data) => {
    return axios.put(AUTH_API_BASE_URL + "/nrg-client-message/" + msgId, data);
};

const getMessageById = (msgId) => {
    return axios.get(AUTH_API_BASE_URL + "/nrg-client-message/" + msgId);
};

const deleteMessage = (msgId) => {
    return axios.delete(AUTH_API_BASE_URL + "/nrg-client-message/" + msgId);
};

export default {
    getServices,
    postServices,
    updateService,
    getServiceById,
    deleteService,
    uploadImages,
    listImages,
    getImage,
    replaceImage,
    updateImageMetadata,
    deleteImage,
    getPendingMessages,
    getDoneMessages,
    getMessages,
    postMessages,
    updateMessages,
    getMessageById,
    deleteMessage,
};
